import React from 'react';
import { ClosingPriceExplorer } from '@components';

const ClosingPrice = () => {
    return (
        <ClosingPriceExplorer
            title="THE Closing Prices"
            description="Browse folders and download CSV files"
            rootPath="/media/files/csv/closing/the/"
            breadcrumbRootLabel="the-closing"
            downloadProduct="THE"
            downloadType="closing"
            searchPlaceholders={{
                0: 'Search currency folder (e.g. EUR)',
                1: 'Search year folder (e.g. 2026)',
                2: 'Search month folder (e.g. 03 or March)',
                3: 'Search filename (e.g. 01.03.2026.csv)',
                default: 'Search filename or date'
            }}
            levelLabels={{
                0: 'Currency',
                1: 'Year',
                2: 'Month',
                3: 'Day',
                default: 'Folder'
            }}
        />
    );
};

export default ClosingPrice;
